import { render, staticRenderFns } from "./tab1-attendance.vue?vue&type=template&id=38a66d9b&scoped=true&"
import script from "./tab1-attendance.vue?vue&type=script&lang=js&"
export * from "./tab1-attendance.vue?vue&type=script&lang=js&"
import style0 from "./tab1-attendance.vue?vue&type=style&index=0&id=38a66d9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a66d9b",
  null
  
)

export default component.exports